export default [
  {
    path: '/resources/farm-owners',
    name: 'farm-owners',
    component: () => import(/* webpackChunkName: 'PageForFarmers' */ '../PageForFarmers'),
    meta: {
      store: ['page/getPageData', 'farm/getStatsData'],
    },
  },
];
